import { Component, ElementRef, Input, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { TabsComponent } from '../Tabs/tabs.component';
import { TabComponent } from '../Tab/tab.component';
import { StepsBannerErrorConfigModel } from '../../../Misc/models/banner-error-config.model';
import { StepStatesEnum } from './step-states.enum';


@Component({
    template: '',
    standalone: false
})
export abstract class StepsNavigationComponent extends TabsComponent implements OnDestroy {
    @Input() allErrors: StepsBannerErrorConfigModel[];

    tabArrowWidth: number = 0;
    tabIconClass = 'agpr-stepsNavigation-tabIcon';

    readonly stepStates = StepStatesEnum;

    subscriptions: Subscription[] = [];

    constructor(protected el: ElementRef<HTMLElement>) {
        super(el);
    }

    protected setClasses() {
        requestAnimationFrame(() => {
            this.tabs?.toArray()
                .filter(x => !!x)
                .forEach(tab => {
                    this.el.nativeElement.querySelector(`#${tab.id}_tabIcon`).className = this.updateTabIcon(tab);
                    this.updateAriaLabel(tab);
                });
        });
    }

    protected updateTabIcon(tab: TabComponent): string {
        let iconClass: string = '';
        switch (tab.iconState) {
            case StepStatesEnum.open:
                iconClass = this.tabIconClass +'--notStarted fa-regular fa-circle';
                break;
            case StepStatesEnum.inProgress:
                iconClass = this.tabIconClass + '--inProgress far fa-circle-ellipsis';
                break;
            case StepStatesEnum.completed:
                iconClass = this.tabIconClass + '--completed fa solid fa-circle-check';
                break;
            case StepStatesEnum.error:
                iconClass = this.tabIconClass + '--error fa solid fa-circle-minus';
                break;
            case StepStatesEnum.warning:
                iconClass = this.tabIconClass + '--warning fa solid fa-circle-exclamation';
                break;
            case StepStatesEnum.selected:
                iconClass = this.tabIconClass + '--selected fa-solid fa-pen-circle';
                break;
            default:
                if (tab.selected) {
                    iconClass = this.tabIconClass + '--selected fa-solid fa-pen-circle';
                } else {
                    iconClass =  this.tabIconClass + '--notStarted fa-regular fa-circle';
                }
        }

        return iconClass;
    }

    protected updateAriaLabel(tab: TabComponent) {
        switch (tab.iconState) {
            case StepStatesEnum.completed:
            case StepStatesEnum.error:
            case StepStatesEnum.warning:
            case StepStatesEnum.inProgress:
                tab.stateAriaLabel = 'Common.stepsNavigation.' + tab.iconState;
                break;
            case StepStatesEnum.selected:
                break;
            case StepStatesEnum.open:
                tab.stateAriaLabel = null;
                break;
        }
    }

    protected clearStepStates(firstStepId: string) {
        this.tabs?.toArray().forEach(tab => {
            if (tab) {
                if (tab.id === firstStepId) {
                    tab.selected = true;
                    tab.iconState = StepStatesEnum.selected;
                } else {
                    tab.selected = false;
                    tab.iconState = null;
                }
            }
        });
    }

    protected abstract handleStepStates(errors: StepsBannerErrorConfigModel[]);

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
